import React from "react";
import { css } from "@balabalabom/ui";
import type { WeatherCondition } from "../lib/weather";

export function WeatherOverlay({ condition }: { condition: WeatherCondition }) {
  return (
    <div
      style={css({
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
        zIndex: 10,
      })}
    >
      {/* subtle tint/veil to boost contrast over images */}
      <div className={`wx-veil wx-veil-${condition}`} />
      {condition === "sunny" && <div className="wx-sun" />}
      {condition === "cloudy" && (
        <>
          <div className="wx-cloud wx-cloud-1" />
          <div className="wx-cloud wx-cloud-2" />
        </>
      )}
      {/* Rain effect inspired by CodePen: https://codepen.io/arickle/pen/XKjMZY */}
      {condition === "rain" && (
        <div className="wx-rain">
          {Array.from({ length: 160 }).map((_, i) => (
            <span
              key={i}
              className="wx-raindrop"
              style={{
                ["--i" as any]: i % 100,
                ["--dur" as any]: `${0.7 + (i % 6) * 0.06}s`,
              }}
            />
          ))}
        </div>
      )}
      {condition === "snow" && (
        <div className="wx-snow">
          {Array.from({ length: 70 }).map((_, i) => (
            <span
              key={i}
              className="wx-snowflake"
              style={{ ["--i" as any]: i % 100 }}
            />
          ))}
        </div>
      )}
      {condition === "wind" && (
        <div className="wx-wind3d">
          {Array.from({ length: 60 }).map((_, i) => {
            const dur = 7 + (i % 8);
            const delay = -(i % 20) * 0.4; // negative so some are already flying
            const x = (i * 13) % 100; // spread across width
            const y = (i * 7) % 100; // spread across height
            const scale = 0.7 + ((i % 10) / 10) * 0.8; // 0.7 - 1.5
            return (
              <span
                key={i}
                className="wx-leaf3d"
                style={{
                  ["--dur" as any]: `${dur}s`,
                  ["--delay" as any]: `${delay}s`,
                  ["--x" as any]: `${x}%`,
                  ["--y" as any]: `${y}%`,
                  ["--scale" as any]: scale,
                  ["--spin" as any]: (i * 97) % 720,
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
